<!-- =========================================================================================
    File Name: AgGridTable.vue
    Description: Ag Grid table
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div id="ag-grid-demo">
        <div class="flex flex-wrap justify-between items-center mb-5">
<!--            <div class="mb-5 md:mb-0 mr-5 ag-grid-table-actions-left" style="display: flex">
                <div class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="year" @change="refresh" class="input-select vs-select&#45;&#45;input" style="padding: 8.8px;">
                            <option :key="index" :value="item" v-for="(item,index) in years">{{ item }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <div v-if="userInfo.type_id === 1" class="con-select select-large" style="width: auto">
                    <div class="input-select-con">
                        <select v-model="country_id" @change="refresh" class="input-select vs-select&#45;&#45;input">
                            <option :key="index" :value="item.id" v-for="(item,index) in countries">{{ item.name }}</option>
                        </select>
                    </div>
                </div>
                &nbsp;&nbsp;&nbsp;&nbsp;
                <vs-checkbox v-model="markup">&nbsp;{{ $t('Markup') }}</vs-checkbox>
            </div>-->

        </div>

        <div class="vx-row m-0">
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Company Name</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Markup</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Reseller</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Customer</div>
            <div class="vx-col sm:w-1/5 w-full" style="font-weight: 600;font-size: .85rem;">Subscriptions</div>
        </div>

        <div v-for="(item) in items" id="category_tree">
            <vx-card class="mt-5">
                <div class="vx-row">
                    <div class="vx-col sm:w-1/5 w-full">{{ item.company_name }}</div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                    <div class="vx-col sm:w-1/5 w-full"></div>
                </div>

                <div v-if="item.childs" v-for="(reseller) in item.childs" class="ml-5 mt-2" :class="'child_'+reseller.id" style="border-top:1px solid black">
                    <div class="vx-row">
                        <div class="vx-col sm:w-1/5 w-full">{{ reseller.company_name }}</div>
                        <div class="vx-col sm:w-1/5 w-full">{{ reseller.markup.title }}</div>
                        <div class="vx-col sm:w-1/5 w-full">
                            <vs-button @click="getResellerInformation(reseller.reseller)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                        </div>
                        <div class="vx-col sm:w-1/5 w-full"></div>
                        <div class="vx-col sm:w-1/5 w-full"></div>
                    </div>

                    <div v-if="reseller.childs" v-for="(customer, key) in reseller.childs" class="ml-5" :class="{['child_'+customer.id]:true, 'bg-grey-light':key % 2 === 0}">
                        <div class="vx-row">
                            <div class="vx-col sm:w-1/5 w-full">{{ customer.company_name }}</div>
                            <div class="vx-col sm:w-1/5 w-full">{{ customer.markup.title }}</div>
                            <div class="vx-col sm:w-1/5 w-full"></div>
                            <div class="vx-col sm:w-1/5 w-full">
                                <vs-button @click="getCustomerInformation(customer.customer)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                            </div>
                            <div class="vx-col sm:w-1/5 w-full">
                                <vs-button @click="getCustomerISubscriptions(customer.customer)" class="btn-drop" type="flat" size="small" color="primary" icon-pack="feather" icon="icon-eye"></vs-button>
                            </div>
                        </div>
                    </div>

                </div>

            </vx-card>
        </div>

        <div>
            <vs-popup class="holamundo" v-bind:title="'Reseller Information'" :active.sync="openResellerPopup">
                <table v-if="popupDetails.resellerId" style="font-size:13px">
                    <tr><td>Reseller ID </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.resellerId }}</td></tr>
                    <tr><td>Company Name </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.companyName }}</td></tr>
                    <tr><td>Country </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.country }}</td></tr>
                    <tr><td>City </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.city }}</td></tr>
                    <tr><td>Postal Code </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.postalCode }}</td></tr>
                    <tr><td>Address </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.addressLine1 }}</td></tr>
                    <tr><td>Address 2 </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.addressLine2 }}</td></tr>
                    <tr><td>Contact </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].firstName }} {{ popupDetails.companyProfile.contacts[0].lastName }}</td></tr>
                    <tr><td>Contact Phone </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].phoneNumber }}</td></tr>
                    <tr><td>Contact Email </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].email }}</td></tr>
                    <tr><td>Market Segment </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.marketSegments.join(", ") }}</td></tr>
                </table>
            </vs-popup>
        </div>

        <div>
            <vs-popup class="holamundo" v-bind:title="'Customer Information'" :active.sync="openCustomerPopup">
                <table v-if="popupDetails.customerId" style="font-size:13px">
                    <tr><td>Customer ID </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.customerId }}</td></tr>
                    <tr><td>Company Name </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.companyName }}</td></tr>
                    <tr><td>Level </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.discounts[0].level }}</td></tr>
                    <tr><td>Coterm Date </td><td>&nbsp;:&nbsp;</td><td>{{ new Date(popupDetails.cotermDate).toLocaleDateString() }}</td></tr>
                    <tr><td>Country </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.country }}</td></tr>
                    <tr><td>City </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.city }}</td></tr>
                    <tr><td>Postal Code </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.postalCode }}</td></tr>
                    <tr><td>Address </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.addressLine1 }}</td></tr>
                    <tr><td>Address 2 </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.address.addressLine2 }}</td></tr>
                    <tr><td>Contact </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].firstName }} {{ popupDetails.companyProfile.contacts[0].lastName }}</td></tr>
                    <tr><td>Contact Phone </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].phoneNumber }}</td></tr>
                    <tr><td>Contact Email </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.contacts[0].email }}</td></tr>
                    <tr><td>Market Segment </td><td>&nbsp;:&nbsp;</td><td>{{ popupDetails.companyProfile.marketSegment }}</td></tr>
                </table>
            </vs-popup>
        </div>

        <div>
            <vs-popup class="holamundo" v-bind:title="'Customer Subscriptions'" :active.sync="openSubscriptionsPopup">
                <div>Total Count: {{ popupDetails.totalCount }}</div>
                <table v-if="popupDetails.items" style="font-size:13px">
                    <tr style="font-weight: bold">
                        <td>Subscription ID</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Offer ID</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Current Quantity</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Used Quantity</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Auto Renewal</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Renewal Quantity</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Creation Date</td>
                        <td>&nbsp;&nbsp;&nbsp;</td>
                        <td>Renewal Date</td>
                    </tr>
                    <tr v-for="(subscription) in popupDetails.items">
                        <td>{{ subscription.subscriptionId }}</td>
                        <td></td>
                        <td>{{ subscription.offerId }}</td>
                        <td></td>
                        <td>{{ subscription.currentQuantity }}</td>
                        <td></td>
                        <td>{{ subscription.usedQuantity }}</td>
                        <td></td>
                        <td>
                            <span @click="openSubscriptionEditPopup(subscription)" style="cursor:pointer;">
                                <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="14px" width="14px" version="1.1" id="Capa_1" viewBox="0 0 306.637 306.637" xml:space="preserve">
                                    <path d="M12.809,238.52L0,306.637l68.118-12.809l184.277-184.277l-55.309-55.309L12.809,238.52z M60.79,279.943l-41.992,7.896    l7.896-41.992L197.086,75.455l34.096,34.096L60.79,279.943z"/>
                                    <path d="M251.329,0l-41.507,41.507l55.308,55.308l41.507-41.507L251.329,0z M231.035,41.507l20.294-20.294l34.095,34.095    L265.13,75.602L231.035,41.507z"/>
                                </svg>
                            </span>
                            <span style="padding-left: 6px;">{{ subscription.autoRenewal.enabled ? 'Yes' : 'No' }}</span>
                        </td>
                        <td></td>
                        <td>{{ subscription.autoRenewal.renewalQuantity }}</td>
                        <td></td>
                        <td style="white-space: nowrap;">{{ new Date(subscription.creationDate).toLocaleString('az-AZ', {timeZone: 'Asia/Baku'}) }}</td>
                        <td></td>
                        <td>{{ new Date(subscription.renewalDate).toLocaleDateString() }}</td>
                    </tr>
                </table>
            </vs-popup>
        </div>

        <div>
            <vs-popup class="holamundo" v-bind:title="'Edit Subscription'" :active.sync="subscriptionEditPopup">
                <table v-if="selectedCustomer.customerId && selectedSubscription.subscriptionId" style="font-size:13px">
                    <tr>
                        <td>Auto Renewal</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>
                            <select v-model="autoRenewal.enabled" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :value="true">Yes</option>
                                <option :value="false">No</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td>Renewal Quantity</td>
                        <td>&nbsp;:&nbsp;</td>
                        <td>
                            <select v-model="autoRenewal.renewalQuantity" class="input-select vs-select--input" style="padding: 8.8px;">
                                <option :key="n" :value="n" v-for="n in selectedSubscription.currentQuantity">{{ n }}</option>
                            </select>
                        </td>
                    </tr>
                    <tr>
                        <td></td>
                        <td></td>
                        <td><vs-button color="success" type="filled" @click="saveSubscription()">{{ $t('save') }}</vs-button></td>
                    </tr>
                </table>
            </vs-popup>
        </div>


    </div>
</template>

<script>
export default {
    data() {
        return {
            userInfo: window.userInfo,
            openResellerPopup: false,
            openCustomerPopup: false,
            openSubscriptionsPopup: false,
            subscriptionEditPopup: false,
            selectedCustomer: {},
            selectedSubscription: {},
            autoRenewal:{
                enabled: true,
                renewalQuantity: 1
            },
            modalTitle: '',
            items: [],
            popupDetails: {},
        }
    },

    created() {
        this.$vs.loading();
        const thisIns = this;
        thisIns.getData();

    },
    methods: {
        getData(){
            this.$vs.loading();
            const thisIns = this;

            axios.get(apiUrl+'/adobe/get-all-users-list?token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.items = data.data;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
        getResellerInformation(reseller){
            this.popupDetails = reseller;
            this.openResellerPopup = true;
        },
        getCustomerInformation(customer){
            this.popupDetails = customer;
            this.openCustomerPopup = true;
        },
        getCustomerISubscriptions(customer){
            this.$vs.loading();
            const thisIns = this;
            this.selectedCustomer = customer;

            axios.get(apiUrl+'/adobe/get-customer-subscription?adobeId='+customer.customerId+'&token='+token)
                .then(function (response) {

                    let data = response.data;
                    if(data.code === 200){
                        thisIns.popupDetails = data.data;
                        thisIns.openSubscriptionsPopup = true;
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
        openSubscriptionEditPopup(subscription){
            this.selectedSubscription = subscription;
            this.autoRenewal.enabled = subscription.autoRenewal.enabled;
            this.autoRenewal.renewalQuantity = subscription.autoRenewal.renewalQuantity;
            this.subscriptionEditPopup = true;
            this.openSubscriptionsPopup = false;
        },
        saveSubscription(){
            this.$vs.loading();
            const thisIns = this;

            axios.post(
                apiUrl+'/adobe/update-customer-subscription?customerId='+this.selectedCustomer.customerId+'&subscriptionId='+this.selectedSubscription.subscriptionId+'&token='+token,
                this.autoRenewal
            )
                .then(function (response) {
                    let data = response.data;
                    if(data.code === 200){
                        thisIns.subscriptionEditPopup = false;
                        thisIns.openSubscriptionsPopup = false;
                        thisIns.selectedCustomer = {};
                        thisIns.selectedSubscription = {};
                    }else{
                        if (data.code === 401){
                            window.logout();
                        }
                        thisIns.$vs.notify({
                            title: 'Error',
                            text:  data.message,
                            color: 'danger',
                            iconPack: 'feather',
                            icon: 'icon-alert-circle'
                        });
                    }
                    thisIns.$vs.loading.close();
                });
        },
    },
}

</script>


<style lang="scss" scoped>

#category_tree{
    .child{
        display: none;
        &.active{
            display: block;
        }
    }
    .text-bold{
        font-weight: bold;
    }
    .color-green{
        color: #43a047;
    }
}


.vs-table--tbody{
    border: 0 !important;

    .vs-table--tbody-table{
        .vs-table--thead th{
            border-bottom: 1px solid #e2e2e2;
        }
        .tr-values td{
            border-bottom: 1px solid #e2e2e2;
        }
    }

    .text-bold{
        font-weight: bold;
    }
    .color-green{
        color: #43a047;
    }
}
</style>
